export default __webpack_public_path__ + "static/media/notfound.e8f73c65.png";